module.exports = __webpack_public_path__ + "static/media/Bean Eater-1s-204px.dc34ecc9.svg";